import React from "react";

// NOVA Landing Page (reforma 2026). A versão antiga foi preservada em
// index_ANTIGA_backup.js — para voltar a ela, é só reimportar de lá.
import NovaLandpage from "./NovaLandpage";

export default function Landpage(props) {
  return <NovaLandpage {...props} />;
}
